import WebApp from '@twa-dev/sdk';

import axios from 'axios';

const baseUrl = import.meta.env.DEV
  ? 'http://localhost:8000/trade/'
  : 'https://tokens-backend.tradyfi.io/trade/';

const instance = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
});

instance.interceptors.request.use(async (config) => {
  const initData = WebApp.initData;
  if (initData) {
    config.headers.Authorization = btoa(initData);
  }

  if (['post', 'put', 'delete'].includes(config.method?.toLowerCase() || '')) {
    const response = await fetch(`${baseUrl}token/`, {
      credentials: 'include',
    });

    if (response.status === 500) {
      throw new Error('Server error while fetching CSRF token');
    }

    const { csrfToken } = await response.json();
    config.headers['X-CSRFToken'] = csrfToken;
  }

  return config;
});

export default instance;
